import createModalModel from './lib/create_modal_model';

export default createModalModel({
  modelName: 'WebhookVerification',
  properties: {},
});



// WEBPACK FOOTER //
// ./src/scripts/domain/models/modal/webhook_verification.js